import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/svg/quotes.svg'


const _hoisted_1 = { class: "section columns" }
const _hoisted_2 = { class: "small-text flex flex-col" }
const _hoisted_3 = { class: "flex justify-end items-center" }
const _hoisted_4 = { class: "!mb-0 !mt-0" }
const _hoisted_5 = { class: "mt-0" }
const _hoisted_6 = { class: "text-pink-300 italic" }
const _hoisted_7 = { class: "flex-grow" }
const _hoisted_8 = { class: "small-text flex flex-col" }
const _hoisted_9 = { class: "flex justify-start items-center" }
const _hoisted_10 = { class: "!mb-0 !mt-0" }
const _hoisted_11 = { class: "mt-0" }
const _hoisted_12 = { class: "text-pink-300 italic" }
const _hoisted_13 = { class: "flex-grow" }
const _hoisted_14 = { class: "section" }
const _hoisted_15 = { class: "objave-grid" }
const _hoisted_16 = { class: "section flex flex-col items-center" }
const _hoisted_17 = { class: "!mt-0" }
const _hoisted_18 = { class: "buttons-container" }

import ArticleModalContent from '@/components/ArticleModalContent.vue'
import ObjavaCard from '@/components/ObjavaCard.vue'
import SocialButtons from '@/views/mainPage/SocialButtons.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ONas',
  emits: ["close", "navigate"],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_a_circular_image = _resolveComponent("a-circular-image")!

  return (_openBlock(), _createBlock(ArticleModalContent, {
    title: _ctx.$t('articles.onas.title'),
    cover: require('@/assets/covers/o-nas.jpg'),
    "cover-offset": ['center', 'top'],
    "content-style": { 'margin-top': '-120px' },
    onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
    "no-contact-form": true,
    "language-button-align": "center"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_circular_image, {
              image: require('@/assets/urska.jpg'),
              float: "none",
              class: "!mr-1"
            }, null, 8, ["image"])
          ]),
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('articles.onas.urska.name')), 1),
          _createElementVNode("p", _hoisted_5, [
            _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.onas.urska.title')), 1)
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("hr", { class: "narrow" }, null, -1)),
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('articles.onas.urska.poklicnoTitle')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.onas.urska.poklicnoP1')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.onas.urska.poklicnoP2')), 1),
          _cache[2] || (_cache[2] = _createElementVNode("img", {
            src: _imports_0,
            alt: "",
            class: "quotes-icon float-left mr-3"
          }, null, -1)),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('articles.onas.urska.quote')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.onas.urska.poklicnoP3')), 1),
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('articles.onas.urska.osebnoTitle')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.onas.urska.osebnoP1')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.onas.urska.osebnoP2')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.onas.urska.osebnoP3')), 1),
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('articles.onas.urska.zanimivostiTitle')), 1),
          _createElementVNode("ul", _hoisted_7, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('articles.onas.urska.zanimivosti1')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('articles.onas.urska.zanimivosti2')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('articles.onas.urska.zanimivosti3')), 1)
          ])
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("hr", { class: "mobile-only" }, null, -1)),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_a_circular_image, {
              image: require('@/assets/photos/katja.jpg'),
              float: "none"
            }, null, 8, ["image"])
          ]),
          _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.$t('articles.onas.katja.name')), 1),
          _createElementVNode("p", _hoisted_11, [
            _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.onas.katja.title')), 1)
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("hr", { class: "narrow" }, null, -1)),
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('articles.onas.katja.poklicnoTitle')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.onas.katja.poklicnoP1')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.onas.katja.poklicnoP2')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.onas.katja.poklicnoP3')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.onas.katja.poklicnoP4')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.onas.katja.poklicnoP5')), 1),
          _cache[4] || (_cache[4] = _createElementVNode("img", {
            src: _imports_0,
            alt: "",
            class: "quotes-icon float-left mr-3"
          }, null, -1)),
          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('articles.onas.katja.quote')), 1),
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('articles.onas.katja.osebnoTitle')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.onas.katja.osebnoP1')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.onas.katja.osebnoP2')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.onas.katja.osebnoP3')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.onas.katja.osebnoP4')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.onas.katja.osebnoP5')), 1),
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('articles.onas.katja.zanimivostiTitle')), 1),
          _createElementVNode("ul", _hoisted_13, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('articles.onas.katja.zanimivosti1')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('articles.onas.katja.zanimivosti2')), 1),
            _createElementVNode("li", null, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('articles.onas.katja.zanimivosti3', {
                                    quote: _ctx.$t('articles.onas.katja.zanimivosti3Quote'),
                                })), 1)
            ])
          ])
        ])
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('articles.onas.mediaTitle')), 1),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(ObjavaCard, {
            date: `maj 2026`,
            service: _ctx.$t('articles.onas.media.vasKanalService'),
            title: _ctx.$t('articles.onas.media.vasKanalTitle'),
            description: _ctx.$t('articles.onas.media.vasKanalDescription'),
            href: "https://vaskanal.com/delavnica-o-ustnem-zdravju-za-starejse/",
            "track-id": "vaskanal-2026-05",
            background: `url(${require('@/assets/podcast-backgrounds/vas-kanal-2026.jpg')})`,
            "background-position": "center left",
            logo: require('@/assets/logos/vaskanal.png')
          }, null, 8, ["service", "title", "description", "background", "logo"]),
          _createVNode(ObjavaCard, {
            date: `${_ctx.$t('general.march')} 2026`,
            service: _ctx.$t('articles.onas.media.rtv1SvetovalniServis'),
            title: _ctx.$t('articles.onas.media.rtvTitle3'),
            description: _ctx.$t('articles.onas.media.rtv1SvetovalniDescription'),
            href: "https://prvi.rtvslo.si/podkast/svetovalni-servis/88/175207677",
            "track-id": "rtv-2026-03",
            logo: require('@/assets/logos/rtvslo.svg'),
            background: `url(${require('@/assets/podcast-backgrounds/rtv-prvi-marec-2026.jpg')})`
          }, null, 8, ["date", "service", "title", "description", "logo", "background"]),
          _createVNode(ObjavaCard, {
            date: `${_ctx.$t('general.july')} 2025`,
            service: _ctx.$t('articles.onas.media.poslusamSeService'),
            title: _ctx.$t('articles.onas.media.poslusamSeTitle'),
            description: _ctx.$t('articles.onas.media.poslusamSeDescription'),
            href: "https://www.poslusam.se/39-otroski-zobje-od-a-do-z/",
            "track-id": "poslusam-se-2025-07",
            background: `url(${require('@/assets/podcast-backgrounds/poslusam-se.jpg')})`,
            logo: require('@/assets/logos/poslusam-se.png')
          }, null, 8, ["date", "service", "title", "description", "background", "logo"]),
          _createVNode(ObjavaCard, {
            date: `${_ctx.$t('general.march')} 2025`,
            service: _ctx.$t('articles.onas.media.rtv1SvetovalniServis'),
            title: _ctx.$t('articles.onas.media.rtv1Title'),
            description: _ctx.$t('articles.onas.media.rtv1SvetovalniDescription'),
            href: "https://prvi.rtvslo.si/podkast/svetovalni-servis/88/175118091",
            "track-id": "rtv-2025-03",
            logo: require('@/assets/logos/rtvslo.svg'),
            background: "linear-gradient(124deg,rgba(126, 93, 166, 1) 0%, rgba(137, 142, 201, 1) 32%, rgba(94, 81, 130, 1) 75%, rgba(64, 50, 92, 1) 90%)"
          }, null, 8, ["date", "service", "title", "description", "logo"]),
          _createVNode(ObjavaCard, {
            date: `${_ctx.$t('general.march')} 2025`,
            service: _ctx.$t('articles.onas.media.ogledaloService'),
            title: _ctx.$t('articles.onas.media.ogledaloTitle'),
            description: _ctx.$t('articles.onas.media.ogledaloDescription'),
            href: "https://spelakresnik.com/epizoda-64-kaj-imata-skupnega-dusevno-zdravje-in-zdravje-zob-z-ursko-savli/",
            "track-id": "ogledalo-2025-03",
            background: `url(${require('@/assets/podcast-backgrounds/ogledalo.jpg')})`,
            logo: require('@/assets/logos/spela-kresnik.png')
          }, null, 8, ["date", "service", "title", "description", "background", "logo"]),
          _createVNode(ObjavaCard, {
            date: `${_ctx.$t('general.october')} 2024`,
            service: _ctx.$t('articles.onas.media.sreckaService'),
            title: _ctx.$t('articles.onas.media.sreckaTitle'),
            description: _ctx.$t('articles.onas.media.sreckaDescription'),
            href: "https://www.youtube.com/watch?v=dfhplqScq-w",
            "track-id": "srecka-2024-10",
            background: `url(${require('@/assets/podcast-backgrounds/srecka.jpg')})`,
            logo: require('@/assets/logos/srecka.png')
          }, null, 8, ["date", "service", "title", "description", "background", "logo"]),
          _createVNode(ObjavaCard, {
            date: `${_ctx.$t('general.july')} 2024`,
            service: _ctx.$t('articles.onas.media.aktivniService'),
            title: _ctx.$t('articles.onas.media.aktivniTitle'),
            description: _ctx.$t('articles.onas.media.aktivniDescription'),
            href: "https://aktivni.metropolitan.si/podkast/dr-urska-savli-ni-zdravega-telesa-brez-tega/",
            "track-id": "aktivni-2024-07",
            background: `url(${require('@/assets/podcast-backgrounds/aktivni.jpg')})`,
            "background-position": "center left",
            logo: require('@/assets/logos/aktivni-si-logo.svg')
          }, null, 8, ["date", "service", "title", "description", "background", "logo"]),
          _createVNode(ObjavaCard, {
            date: `${_ctx.$t('general.december')} 2023`,
            service: _ctx.$t('articles.onas.media.rtv1SvetovalniServis'),
            title: _ctx.$t('articles.onas.media.rtv2Title'),
            description: _ctx.$t('articles.onas.media.rtv1SvetovalniDescription'),
            href: "https://prvi.rtvslo.si/podkast/svetovalni-servis/88/175010106",
            "track-id": "rtv-2023-12",
            logo: require('@/assets/logos/rtvslo.svg'),
            background: "linear-gradient(124deg,rgba(126, 93, 166, 1) 0%, rgba(137, 142, 201, 1) 32%, rgba(94, 81, 130, 1) 75%, rgba(64, 50, 92, 1) 90%)"
          }, null, 8, ["date", "service", "title", "description", "logo"])
        ])
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("h2", _hoisted_17, _toDisplayString(_ctx.$t('home.sections.followUs')), 1),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(SocialButtons, { color: "#df8aa0" })
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "cover"]))
}
}

})